import type { ReactNode } from 'react';
import { ThemeToggle } from '@/ui';
import { LeadGenLogo } from './components/LeadGenLogo';
import styles from './AuthShell.module.css';

export interface AuthShellProps {
  readonly title: string;
  readonly subtitle?: string | undefined;
  readonly children: ReactNode;
  readonly footer?: ReactNode | undefined;
}

/**
 * Shared frame for the signed-out screens (Forgot Password, Reset Password, etc.)
 */
export function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div className={styles.page}>
      <div className={styles.themeSlot}>
        <ThemeToggle />
      </div>

      <main className={styles.card}>
        <div style={{ marginBottom: '24px' }}>
          <LeadGenLogo size="md" />
        </div>

        <h1 className={styles.title}>{title}</h1>
        {subtitle !== undefined && <p className={styles.subtitle}>{subtitle}</p>}

        <div className={styles.content}>{children}</div>

        {footer !== undefined && <div className={styles.footer}>{footer}</div>}
      </main>
    </div>
  );
}
